import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import { useChatCsatStore } from "../hooks/ChatCsatContextStore";

export const CsatTitle: React.FC = () => {
  const [{ surveyType }] = useChatCsatStore(["surveyType"]);
  if (surveyType === "chat") {
    return (
      <Typography variant="pageHeaderSerifRegular" color={Core.text.default}>
        <StrictLocalMsg
          defaultMessage="How can we improve?"
          description={{
            text: "Title of the customer satisfaction collection page for chat",
            img: "https://cdn.faire.com/fastly/c322d4cd11585c492833dd61b13d958814da01f11b79b5038c89b1a928e1b2a4.png",
          }}
        />
      </Typography>
    );
  }
  return (
    <>
      <Typography variant="pageHeaderSerifRegular" color={Core.text.default}>
        <StrictLocalMsg
          defaultMessage="Help us improve"
          description={{
            text: "Title of the customer satisfaction collection page",
            img: "https://cdn.faire.com/fastly/7c15fe7ae1b4dafba8eda204859c6f3993bc8168f43f6dc2368fad594aa7940b.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <Typography variant="paragraphSansRegular" color={Core.text.default}>
        <StrictLocalMsg
          defaultMessage="Your feedback is very valuable to us. Please share how your support experience could’ve been better."
          description={{
            text: "Description of the customer satisfaction collection page",
            img: "https://cdn.faire.com/fastly/b0e720ebc13dfcb2c3ca8155707dd742e6dbdbf45557de5b3f23885b0800673c.png",
          }}
        />
      </Typography>
    </>
  );
};
